import React from "react";

import logoConverge from "../img/logo_converge_white.png";
import imgAmySchumer from "../img/persona_icon.png";
import imgFiltered from "../img/cuadro_icon.png";
import imgMatched from "../img/match_icon.png";

import gestureEyesClosed from "../img/ojoscerrados_icon.png";
import gestureEyeClosed from "../img/ojo_icon.png";
import gestureSmiling from "../img/sonrisa_icon.png";

import AOS from "aos";
import "aos/dist/aos.css";

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.aos = AOS;
    this.aos.init();
  }

  render() {
    return (
      <div>
        <div className="header">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 centered">
                <h1>
                  Experiencia
                  <br />
                  <span className="fwextrabold">Globant AI</span>
                </h1>
                <p>
                  Powered by <span className="fwsemibold">Globant Minds</span>
                </p>
                <img
                  src={logoConverge}
                  className="logoConverge"
                  alt="Converge"
                />
                <h6>
                  ¡Muchas gracias por participar de la <br />
                  experiencia <span className="fwsemibold">AI</span> en el marco
                  de la Converge!
                </h6>
              </div>
            </div>
          </div>
          <div className="header__scroll">
            <span />
          </div>
        </div>

        <div className="featured">
          <div className="container mtb">
            <div className="row">
              <div className="col-md-6" data-aos="fade-up">
                <h2>
                  Reconocimiento Facial <br /> Similitud Facial
                </h2>
                <p>
                  Registrarse para ingresar o ser atendido en cualquier lugar
                  suele ser una gran incomodidad, sea en edificios, consultas
                  médicas, o trámites bancarios.
                </p>
                <p>
                  Usando AI, se puede evitar el proceso al reconocer al
                  individuo. Esto se logra porque la AI aprende cómo comparar la
                  imagen contra registros previos y decidir que son tan
                  similares que representan a la misma persona.
                </p>
                <p>
                  Como parte de la experiencia, analizamos tu rostro y hemos
                  encontrado una celebridad con la cual presentan algun grado de
                  similitud.
                </p>
              </div>
              <div
                className="col-md-6 centered"
                data-aos="fade-left"
                data-aos-delay="300"
              >
                <img
                  src={imgMatched}
                  className="imgMatched img-responsive mt"
                  alt=""
                />
                <p className="matchphrase">
                  Veo que tienes cierto parecido con{" "}
                  <span className="fwsemibold">Amy Schumer (Actriz)</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="featured age-detection bluebg">
          <div className="container mtb">
            <div className="row">
              <div
                className="col-md-6 centered"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <img
                  src={imgAmySchumer}
                  className="imgGeneration img-responsive"
                  alt=""
                />
                <p>También puedo ver que eres de la:</p>
                <div className="btn btn-conf-2">Generación Y</div>
                <p className="fwlight">(Naciste entre 1982 y 1994)</p>
              </div>
              <div className="col-md-6" data-aos="fade-down">
                <h2>Reconocimiento de Edad</h2>
                <p>
                  El reconocimiento facial se puede complementar con un
                  reconocimiento de edad y/o del género de la persona. Durante
                  la experiencia, gracias a AI, hemos detectado tu rango etario
                  y lo hemos traducido a una generación (Millenial, Centennial,
                  etc).
                </p>
                <p>
                  Dentro de un local comercial, el uso de AI para la
                  idenficación de género y/o rango etario permite conocer
                  quiénes son los clientes (aún sin saber identidad) y de esta
                  manera entender a quién se le vende y en qué momento, lo que
                  permite poder adaptar mejor la oferta.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="featured">
          <div className="container mtb">
            <div className="row">
              <div className="col-md-6" data-aos="fade-up">
                <h2>Reconocimiento de Gestos</h2>
                <p>
                  Durante la experiencia, te pedimos realizar algunos gestos y
                  los hemos reconocido.
                </p>
                <p>
                  El reconocimiento de gestos permite (entre otras cosas) saber
                  si realmente la persona identificada está allí y no sea una
                  foto o video pre-grabado. Esto puede ser usado en casos en los
                  cuales sea necesario dar una prueba de vida, permitiendo
                  realizarla de forma remota y evitando así traslados
                  (especialmente útil en personas con movilidad reducida).
                </p>
                <p>
                  Otros usos del reconocimiento de gestos y/o movimientos es que
                  permite detectar, por ejemplo, si un conductor se está
                  quedando dormido o está ebrio, si está sufrieno algún ataque
                  cerebral o del corazón, y de esta manera poder prevenir un
                  accidente y enviar ayuda en forma inmediata.
                </p>
                <p>
                  El reconocimiento de gestos no está limitado sólo a los gestos
                  faciales. AI puede ser usado para leer gestos del cuerpo; por
                  ejemplo, se podría crear un traductor de lengua de señas
                  mediante el reconocimiento de los gestos realizados con las
                  manos.
                </p>
              </div>
              <div
                className="col-md-6"
                data-aos="fade-left"
                data-aos-delay="300"
              >
                <div className="gestures-box">
                  <div className="gesture imgEyesClosed">
                    <img src={gestureEyesClosed} />
                    <span>Dos ojos cerrados</span>
                  </div>

                  <div className="gesture imgSmile">
                    <img src={gestureSmiling} />
                    <span>Sonrisa</span>
                  </div>

                  <div className="gesture imgEyeWink">
                    <img src={gestureEyeClosed} />
                    <span>Ojo cerrado</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="featured bluebg">
          <div className="container mtb">
            <div className="row">
              <div
                className="col-md-6 centered"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <img
                  src={imgFiltered}
                  className="imgFiltered aligncenter img-responsive mt"
                  alt=""
                />
                <p>
                  ¡Felicitaciones!
                  <br />
                  Edvard Munch acaba de pintarte un retrato
                </p>
              </div>
              <div className="col-md-6" data-aos="fade-down">
                <h2>Transferencia de Estilos</h2>
                <p>
                  Durante la experiencia, te demostramos que pudimos aplicar un
                  estilo pictórico sobre una foto tuya.
                </p>
                <p>
                  AI puede aprender y aplicar cosas tan complejas como
                  contenido, forma y estilo. Esto no solo de un estilo pictórico
                  sino también de estilos de escritura, prosodia y tono de
                  audio, o formalidad de lenguaje.
                </p>
                <p>
                  Un ejemplo de uso es permitir aplicar un estilo de branding
                  sobre todas las imágenes corportativas de una empresa. Otro
                  ejemplo de uso es cambiar los estilos de imágenes para que
                  sean visibles para personas con problemas de daltonismo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js